module.exports = __webpack_public_path__ + "img/home_map.fc49aec5.png";